module.exports = __webpack_public_path__ + "static/media/esports-page-grid-2.9d419a88.jpg";